import React, { useEffect } from 'react';
import './App.css';

function App() {
  useEffect(() => {
    const getRedirectUrl = () => {
      const hostname = window.location.hostname;
      const currentPath = window.location.pathname + window.location.search + window.location.hash;
      
      let baseUrl;
      if (hostname === 'students-dev.quazaredu.com') {
        baseUrl = 'https://learners-dev.quazaredu.com';
      } else if (hostname === 'students.quazaredu.com') {
        baseUrl = 'https://learners.quazaredu.com';
      } else {
        baseUrl = 'https://learners.quazaredu.com';
      }
      
      return baseUrl + currentPath;
    };
    
    const redirectUrl = getRedirectUrl();
    window.location.href = redirectUrl;
  }, []);

  return (
    <div className="App">
      <div className="loader"></div>
    </div>
  );
}

export default App;
